import axios, { AxiosError, AxiosResponse } from "axios";

interface ApiResponse {
    state: string;
    result: any;
}

export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
    withCredentials: true
});

const handleResponse = (response: AxiosResponse<ApiResponse>) => {
    if (response !== undefined) {
        if (response && response.data.state === "success") {
            return response.data.result;
        } else {
            throw new Error(response.data?.result || "API Error");
        }
    }
};

export const apiService = {
    get: async (url: string, config = {}) => {
        try {
            return handleResponse(await apiClient.get(url, {
                ...config,
            }));
        } catch (error) {
            console.log("Get request error: ", error);
            throw error;
        }
    },
    post: async (url: string, data: any, config = {}) => {
        try {
            return handleResponse(await apiClient.post(url, data, {
                ...config,
            }));
        } catch (error) {
            console.log("Post request error: ", error);
            throw error;
        }
    },
    put: async (url: string, data: any, config = {}) => {
        try {
            return handleResponse(await apiClient.put(url, data,{
                ...config,
            }));
        } catch (error) {
            console.log("Put request error: ", error);
            throw error;
        }
    },
    delete: async (url: string) => {
        try {
            return handleResponse(await apiClient.delete(url));
        } catch (error) {
            console.log("Delete request error: ", error);
            throw error;
        }
    }
}

export default apiService;